// insight-slice.js

import { createSlice } from '@reduxjs/toolkit';
import { getPricingAnalytics, getMessageAnalytics } from './insight-action';

const initialState = {
  usageData: [],
  usageLoading: false,
  usageError: null,
  usageLoaded: false,

  messageAnalytics: null,
  messageLoading: false,
};

const insightSlice = createSlice({
  name: 'insight',
  initialState,
  reducers: {
    resetUsageState: (state) => {
      state.usageData = [];
      state.usageLoading = false;
      state.usageError = null;
      state.usageLoaded = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔹 PRICING ANALYTICS
      .addCase(getPricingAnalytics.pending, (state) => {
        state.usageLoading = true;
        state.usageError = null;
      })
      .addCase(getPricingAnalytics.fulfilled, (state, action) => {
        state.usageLoading = false;
        state.usageData = action.payload;
        state.usageLoaded = true;
      })
      .addCase(getPricingAnalytics.rejected, (state, action) => {
        state.usageLoading = false;
        state.usageError = action.payload;
      })

      // 🔹 MESSAGE ANALYTICS (optional)
      .addCase(getMessageAnalytics.pending, (state) => {
        state.messageLoading = true;
      })
      .addCase(getMessageAnalytics.fulfilled, (state, action) => {
        state.messageLoading = false;
        state.messageAnalytics = action.payload;
      })
      .addCase(getMessageAnalytics.rejected, (state) => {
        state.messageLoading = false;
      });
  },
});

export const { resetUsageState } = insightSlice.actions;
export default insightSlice.reducer;
